import React, { CSSProperties, ReactChildren } from "react";
import { styled } from "@mui/material";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

//region [[ Styles ]]

const InfoBoxView = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 4,
  fontSize: 13,
  "& svg": { color: ClinicColors.secondary },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface InfoBoxProps {
  children: React.ReactNode;
  style?: CSSProperties;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InfoBox = ({ ...props }: InfoBoxProps) => {
  return (
    <InfoBoxView style={props.style} className={"clinic-info-box"}>
      <InfoOutlinedIcon fontSize={"small"} />
      {props.children}
    </InfoBoxView>
  );
};
